import { AUDIO_UPLOADABLE_PRESENTATION_TYPES, type AudioPresentationType } from '../api'

export type AudioAssetTabKey =
  | 'all'
  | 'voice_template'
  | 'speech'
  | 'music'
  | 'sfx'
  | 'ambience'
  | 'recording'
  | 'reference_audio'
  | 'mixdown'

export type UploadablePresentationType = Exclude<AudioPresentationType, 'VOICE_TEMPLATE' | 'SPEECH' | 'MIXDOWN'>

const TAB_TO_UPLOADABLE_TYPE: Partial<Record<AudioAssetTabKey, UploadablePresentationType>> = {
  music: 'MUSIC',
  sfx: 'SFX',
  ambience: 'AMBIENCE',
  recording: 'RECORDING',
  reference_audio: 'REFERENCE_AUDIO',
}

/** Map the active Audio Assets tab to the upload modal's initial category.
 * Non-uploadable tabs (all / voice_template / speech / mixdown) fall back to MUSIC. */
export function uploadDefaultPresentationTypeFromTab(activeTab: AudioAssetTabKey): UploadablePresentationType {
  const mapped = TAB_TO_UPLOADABLE_TYPE[activeTab]
  if (mapped && AUDIO_UPLOADABLE_PRESENTATION_TYPES.includes(mapped)) {
    return mapped
  }
  return 'MUSIC'
}
